<template>
  <div id="certification">
    <h5 class="usertitle">实名认证</h5>
    <div class="v8 certification-box">
      <div v-if="renzheng.user_info">
        <!--certification-head中的数据    v-if="renzheng.user_info.qualification == 2" -->
        <div class="certification-head">
          <div class="certification-head-zhuangtai">
            <!--  -->
            <span>审核状态：</span>
            <span
              class="certification-head-zhuangtai-y"
              v-if="renzheng.user_info.qualification == 1"
              >审核中</span
            >
            <span
              class="certification-head-zhuangtai-red"
              v-if="renzheng.user_info.qualification == 3"
              >审核驳回</span
            >
            <span
              class="certification-head-zhuangtai-r"
              v-if="renzheng.user_info.qualification == 2"
              >审核成功</span
            >
          </div>

          <div
            class="certification-head-bohui"
            v-if="renzheng.user_info.qualification == 3"
          >
            <span>驳回原因：</span>
            <span class="certification-head-zhuangtai-red">
              {{ renzheng.user_info.qualification_remark }}</span
            >
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div style="width: 100%">
        <el-form
          ref="form"
          :model="form"
          style="width: 100%"
          label-width="100px"
          :rules="rules"
        >
          <!-- 标题 -->
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="医院名称" prop="hospital">
            <el-input
              v-model="form.hospital"
              placeholder="请输入医院名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="科室" prop="department">
            <el-input
              v-model="form.department"
              placeholder="请输入科室"
            ></el-input>
          </el-form-item>
          <el-form-item label="职称" prop="job_title">
            <!-- <el-input
              v-model="form.job_title"
              placeholder="请输入职称"
            ></el-input> -->
            <el-select v-model="form.job_title" placeholder="请输入职称">
              <el-option value="住院医师">住院医师</el-option>
              <el-option value="主治医师">主治医师</el-option>
              <el-option value="副主任医师">副主任医师</el-option>
              <el-option value="主任医师">主任医师</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医院级别" prop="hospital_level">
            <el-select
              v-model="form.hospital_level"
              placeholder="请选择医院级别"
            >
              <el-option
                v-for="(item, index) in yiyuanjibie"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            prop="cert_file"
            :label="form && form.cert_type ? form.cert_type : ''"
          >
            <!-- <div class="look_Example" @click="lookExample">查看示例</div> -->
            <div class="crad_img_list">
              <el-upload
                class="upload_demo_cert_file"
                list-type="picture-card"
                :action="action"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-success="handleAvatarSuccess"
                multiple
                :limit="2"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :data="uploadData"
                :before-upload="wenBeforeUpload"
                :on-progress="onProgressTest"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <path fill="#dcdfe6" d="M7 7V.5h2V7h6.5v2H9v6.5H7V9H.5V7z" />
                </svg>
                <!-- <el-button
                v-if="!(form.cert_file.split(',').length == 3)"
                class="renzheng-btn"
                size="small"
                type="primary"
                v-prevent="1500"
              >
                点击上传
              </el-button> -->
              </el-upload>
              <div class="look_Example" @click="lookExample">查看示例</div>
            </div>
          </el-form-item>
          <div class="line_dashed"></div>
          <el-form-item label="身份证号" prop="id_card">
            <el-input
              v-model="form.id_card"
              placeholder="请填写身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证照片" prop="id_card_img">
            <el-upload
              class="upload_demo_id_card_img"
              :file-list="fileListCrad"
              list-type="picture-card"
              :action="action"
              multiple
              :limit="2"
              :on-preview="handlePreviewCrad"
              :on-remove="handleRemoveCrad"
              :before-remove="beforeRemoveCrad"
              :on-success="handleAvatarSuccessCrad"
              :on-exceed="handleExceedCrad"
              :data="uploadDataCrad"
              :before-upload="wenBeforeUploadCrad"
              :on-progress="onProgressTestCrad"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path fill="#dcdfe6" d="M7 7V.5h2V7h6.5v2H9v6.5H7V9H.5V7z" />
              </svg>
              <!-- <el-button
                v-if="!(form.id_card_img.split(',').length == 2)"
                class="renzheng-btn"
                size="small"
                type="primary"
                v-prevent="1500"
              >
                点击上传身份证照片
              </el-button> -->
            </el-upload>
          </el-form-item>

          <div class="line_dashed"></div>
          <el-form-item label="开户行" prop="bank_of_deposit">
            <el-input
              v-model="form.bank_of_deposit"
              placeholder="请输入开户行"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行卡账号" prop="bank_card_account_number">
            <el-input
              v-model="form.bank_card_account_number"
              placeholder="请输入银行卡账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行地址" prop="bank_address">
            <el-input
              v-model="form.bank_address"
              placeholder="请填写开户行地址"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="省份/城市" prop="file_type">
            <el-cascader
              style="width: 100%"
              v-model="renzhenValue"
              placeholder="请选择省份/城市"
              :options="options"
              :props="categorProps"
            />
          </el-form-item>

          <el-form-item label="职业" prop="job">
            <el-input v-model="form.job" placeholder="请输入职业"></el-input>
          </el-form-item>

          <el-form-item label="证书类型" prop="cert_type">
            <el-select v-model="form.cert_type" placeholder="请选择文件类型">
              <el-option
                v-for="(item, index) in zhengshuleixing"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item
            style="text-align: center"
            v-if="renzheng.user_info && renzheng.user_info.qualification != 2"
          >
            <el-button
              style="
                background: linear-gradient(127deg, #2fd1c2 0%, #4986fe 100%);
                border-color: #2fd1c2;
              "
              type="primary"
              @click="onSubmit('form')"
            >
              认证
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 内容 -->
    </div>
    <el-dialog :visible.sync="dialogVisibleImg" title="示例图">
      <img
        w-full
        src="../../assets/image/example.png"
        style="width: 100%; height: 100%"
        alt="Preview Image"
      />
    </el-dialog>
  </div>
</template>
<script>
// 引入七牛云
import * as qiniu from "qiniu-js";

// 引入七牛云
import { sevenCloud } from "@/api/createCenter";
import { getuser } from "../../api/user.js";
import { ajaxarea, jibieleixing, renzheng } from "@/api/login.js";
import exampleImg from "../../assets/image/example.png";
export default {
  name: "certification",
  data() {
    return {
      dialogVisibleImg: false,
      dialogImageUrl: "",
      //------------------------------------------
      action: `https://up-z1.qiniup.com`, //http://up-z1.qiniup.com
      fileList: [],
      uploadData: { key: "", token: "" },
      aaa: "",
      //------------------------------------------
      isShowfile_path: false, //上文件进度条
      progressPercentfile_path: 0, //上文件进度条
      renzheng: {},
      form: {
        // _id: this.$route.query.id || "",
        name: "", //用户名
        phone: "", //手机号
        hospital: "", //医院名称
        job: "", //职业
        hospital_level: "", //医院级别
        department: "", //科室
        job_title: "", //职称
        cert_type: "医师资格证", //证书
        cert_file: "", //文件
        province_id: "", //省
        city_id: "", //市
        area_id: "", //区
      },
      renzhenValue: [],
      categorProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      //上传图片
      progressPercentCover_img: 0, //上图图片进度条
      isShowCover_img: false, //上图图片进度条
      // 上传身份证照片
      fileListCrad: [],
      uploadDataCrad: { key: "", token: "" },
      classfiy: [],
      value: "",
      file_type: JSON.parse(localStorage.getItem("class")) || [],
      config: "", // 七牛云的配置项
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "change" }],
        // phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        hospital: [
          { required: true, message: "请输入医院名称", trigger: "change" },
        ],
        job: [{ required: true, message: "请输入职业", trigger: "change" }],
        hospital_level: [
          { required: true, message: "请选医院级别", trigger: "change" },
        ],
        department: [
          { required: true, message: "请输入科室", trigger: "change" },
        ],
        job_title: [
          { required: true, message: "请输入职称", trigger: "change" },
        ],
        // cert_type: [
        //   { required: true, message: "请上传证书类型", trigger: "change" },
        // ],
        cert_file: [
          { required: true, message: "请上传文件", trigger: "change" },
        ],
        id_card: [
          { required: true, message: "请填写身份证号", trigger: "change" },
        ],
        bank_of_deposit: [
          { required: true, message: "请输入开户行", trigger: "change" },
        ],
        bank_card_account_number: [
          { required: true, message: "请输入银行卡账号", trigger: "change" },
        ],
        bank_address: [
          { required: true, message: "请输入开户行地址", trigger: "change" },
        ],
        id_card_img: [
          { required: true, message: "请上传身份证照片", trigger: "change" },
        ],
      },
      options: [],
      yiyuanjibie: [],
      zhengshuleixing: [],
    };
  },
  created() {
    this.getuserApi();
    this.shengshiqu();
    this.jiebie();
  },
  watch: {
    form: {
      handler(newVal) {
        // console.log(newVal, "nwVal");
        if (newVal.id_card_img) {
          const dom_img = document.querySelector(
            ".upload_demo_id_card_img"
          ).children;
          let terget_dom_img = dom_img[1];
          let listCradImg = newVal.id_card_img.split(",");
          if (listCradImg.length == 2) {
            terget_dom_img.style.display = "none";
          } else {
            terget_dom_img.style.display = "inline-block";
          }
        }

        if (newVal.cert_file) {
          const dom_file = document.querySelector(
            ".upload_demo_cert_file"
          ).children;
          let terget_dom_file = dom_file[1];
          let listCertFile = newVal.cert_file.split(",");
          if (listCertFile.length == 3) {
            terget_dom_file.style.display = "none";
          } else {
            terget_dom_file.style.display = "inline-block";
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    //------------------------------------------------------------------------------
    //点击每一个上传后的文件
    handlePreview(file) {
      // console.log(file);
      window.open(file.url);
    },
    //移除后
    handleRemove(file, fileList) {
      this.aaa = "";
      let qiniuUrl = "";
      let apiUrl = "";

      fileList.map((item) => {
        // if (item.response != undefined) {
        //   qiniuUrl += `https://doc.medsky.cn/${item.response.key}` + ",";
        // }
        if (item.url) {
          apiUrl += item.url + ",";
        }
      });
      this.aaa = apiUrl + qiniuUrl;
      this.form.cert_file = this.aaa;
      console.log(this.form.cert_file, "this.form.cert_file");
    },
    //移除文件 提示
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //文件上传成功
    handleAvatarSuccess(res, file) {
      if (res.key != "" || res.key != undefined || res.key != null) {
        this.aaa += `https://doc.medsky.cn/${res.key}` + ",";
        this.form.cert_file += `https://doc.medsky.cn/${res.key}` + ",";
        // this.fileList.push(file);
        file.url = `https://doc.medsky.cn/${res.key}`;
        console.log(file, "file");
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
      } else {
        this.$message.error("上传失败");
      }
    },
    //超出长度提示
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 2 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //上传前
    async wenBeforeUpload(file) {
      const is50M = file.size / 1024 / 1024 < 50;
      if (!is50M) {
        this.$message.error("上传图片大小不能超过 50MB!");
        return false;
      }
      // console.log(file);
      let suffix = file.name.substring(file.name.lastIndexOf(".")); //.txt
      //获取七牛云的token
      const res = await sevenCloud();
      this.uploadData.token = res.data.token;
      //file.uid +
      this.uploadData.key = file.uid + file.name;
      return true;
    },
    //文件上传时
    onProgressTest(event, file, fileList) {
      let index = 0;
      // 只有fileList 跟file 里面的uid是唯一的互相对应的
      fileList.forEach((v, i) => {
        if (v.uid === file.uid) {
          index = i;
        }
      });
      // 获取动态的进度
      let percent = parseInt(event.percent);
      this.$nextTick(() => {
        setTimeout(() => {
          if (percent >= 98) {
            // 当动态的进度超过99就获取dom 让值一直显示99直到上传成功
            let dom = document.getElementsByClassName("el-upload-list__item")[
              index
            ];
            let progressText = dom.getElementsByClassName("el-progress__text");
            console.log(progressText, "progressText");
            if (progressText && progressText.length) {
              progressText[0].style.opacity = 0;
              progressText[0].innerText = "98%";
              progressText[0].style.opacity = 1;
            }
          }
        });
      });
    },
    //------------------------------------------------------------------------------
    // 身份证照片
    handlePreviewCrad(file) {
      console.log(file.url, "qweqwe");
      // this.dialogVisibleImg = true;
      // this.dialogImageUrl = file.url;
      window.open(file.url);
    },

    beforeRemoveCrad(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemoveCrad(file, fileList) {
      let list = [];
      console.log(file, "file", fileList);
      fileList.map((item) => {
        if (item.url) {
          list.push(item.url);
        }
      });
      this.form.id_card_img = list.join(",");
      this.fileListCrad = fileList;
      console.log(this.form.id_card_img, "this.form.id_card_img ");
    },
    handleAvatarSuccessCrad(res, file) {
      console.log(res, "res", file);
      if (res.key !== "" || res.key != undefined || res.key != null) {
        let url = `https://doc.medsky.cn/${res.key}`;
        file.url = url;
        let list = this.form.id_card_img
          ? this.form.id_card_img.split(",")
          : [];
        list.push(url);
        this.form.id_card_img = list.join(",");
        this.fileListCrad.push(file);
        console.log(this.form.id_card_img, "this.form.id_card_img ");
      } else {
        this.$message.error("上传失败");
      }
    },
    handleExceedCrad(files, fileList) {
      this.$message.warning(
        `当前限制选择 2 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    async wenBeforeUploadCrad(file) {
      const is50M = file.size / 1024 / 1024 < 50;
      if (!is50M) {
        this.$message.error("上传图片大小不能超过 50MB!");
        return false;
      }
      let suffix = file.name.substring(file.name.lastIndexOf(".")); //.txt
      //获取七牛云的token
      const res = await sevenCloud();
      this.uploadDataCrad.token = res.data.token;
      //file.uid +
      this.uploadDataCrad.key = file.uid + file.name;
      return true;
    },
    onProgressTestCrad(event, file, fileList) {},
    // -----------------------------------------------------------------------------
    //级别 类型
    async jiebie() {
      const res = await jibieleixing();
      this.yiyuanjibie = res.data.hospital_level;
      this.zhengshuleixing = res.data.cert_file_type;
    },
    //省市区
    async shengshiqu() {
      const res = await ajaxarea();
      this.options = res.data;
    },
    //获取认证信息
    async getuserApi() {
      // 注册成功将返回 qualification字段 : 认证状态;
      // 0=未提交资料
      // 1=已提交待认证
      // 2=认证通过
      // 3=认证驳回
      this.fileList = [];
      const res = await getuser();
      this.renzheng = res.data;
      console.log(
        "测试",
        this.renzheng,
        res.data.user_info?.qualification === 1 ||
          res.data.user_info?.qualification === 2 ||
          res.data.user_info?.qualification === 3
      );
      if (
        res.data &&
        res.data.user_info &&
        res.data.user_info.qualification &&
        (res.data.user_info.qualification === 1 ||
          res.data.user_info.qualification === 2 ||
          res.data.user_info.qualification === 3)
      ) {
        this.form = res.data.user_qualification;
        this.renzhenValue = res.data.user_qualification.ele_area;
        // this.form._id = this.$route.query.id || "";

        //文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件
        let casd = res.data.user_qualification.cert_file.split(",");
        casd.map((i) => {
          this.fileList.push({ url: i, name: i });
        });
        this.form.cert_file = `${this.form.cert_file},`;
        //添加新的不会被替换
        let bbb = this.fileList.map((e) => {
          return e.url;
        });
        let list_file = this.form.id_card_img
          ? this.form.id_card_img.split(",")
          : [];
        this.fileListCrad = [];
        if (list_file && list_file.length) {
          list_file.forEach((item) => {
            this.fileListCrad.push({
              url: item,
              name: item,
            });
          });
        }
        // this.fileListCrad = this.form.id_card_img
        //   ? this.form.id_card_img.split(",")
        //   : [];
        this.aaa += res.data.user_qualification.cert_file + ",";
        //文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件//文件
      }
    },
    //认证
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.form.cert_file = this.aaa.substring(0, this.aaa.length - 1);
          this.form.province_id = this.renzhenValue[0];
          this.form.city_id = this.renzhenValue[1];
          this.form.area_id = this.renzhenValue[2];

          console.log("提交提交提交", this.fileList);
          this.renzhengApi();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //认证接口
    async renzhengApi() {
      //this.form.ele_area
      delete this.form.ele_area;
      const res = await renzheng(this.form);
      if (res.code == 1) {
        console.log(res);
        this.shiming = false;
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    //上传文件
    uploadfile(el) {
      this.isShowfile_path = true;
      this.upload(el, "file_path");
    },
    lookExample() {
      // this.$refs.popupRef.open();
      this.dialogVisibleImg = true;
    },
  },
};
</script>
<style lang="less" scoped>
.crad_img_list {
  display: flex;
  .look_Example {
    margin-left: 10px;
    color: #5b92fe;
    cursor: pointer;
    position: absolute;
    top: 30px;
    left: -85px;
  }
}
.certification-box {
  width: 100%;
  margin-top: 60px;
  margin-left: 10px;

  .certification-head {
    display: flex;
    aling-items: center;
    padding-bottom: 18px;
    border-bottom: 1px solid #ececec;
    margin-bottom: 30px;
    .certification-head-zhuangtai {
      margin-right: 40px;
      font-size: 15px !important;
      .certification-head-zhuangtai-r {
        color: #19ab4a;
      }
      .certification-head-zhuangtai-y {
        color: #fb9622;
      }
    }
    .certification-head-zhuangtai-red {
      color: #ef5f5f;
    }
    .certification-head-bohui {
      font-size: 15px !important;
    }
  }
}
.upload_info {
  width: 100px;
  height: 100px;
  // border: 1px dashed #bfbfbf;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.file_list {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  .left_img {
    height: 100%;
    border-radius: 10px;
    margin-right: 10px;
    :deep(img) {
      height: 100%;
    }
  }
}
// :deep(.el-upload-list--picture) {
//   display: flex;
//   .el-upload-list__item {
//     background: red;
//   }
// }
.avatar-uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 85px;
  height: 48px;
  line-height: 48px;
  text-align: center;
}
.file_img_item {
  width: 100%;
  height: 100%;
  .el-image,
  :deep(img) {
    width: 100%;
    height: 100%;
  }
  .iconfont:hover {
    background: #19ab4a;
    color: #fff !important;
  }
  .iconfont {
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 5px;
    border-radius: 10px;
    // background: #19ab4a;
  }
}
.avatar {
  width: 85px;
  height: 48px;
  display: block;
}
/deep/ .el-dialog__header {
  background: linear-gradient(180deg, #dbffef 0%, #ffffff 100%);
  color: #fff;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}

.el-form {
  // width: 90%;
  /deep/ .el-form-item {
    width: 90%;
    // margin-bottom: 60px;
    margin-bottom: 40px;
    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
}
</style>
